/**
 * Chart Suggestion Card.
 * Displays suggested charts for the dataset.
 */

import React from 'react';
import type { ChartSuggestion } from '@excel-ai-studio/shared';
import { CHART_TYPE_LABELS } from '@excel-ai-studio/shared';
import { ResultCard } from '../common/ResultCard';

interface ChartSuggestionCardProps {
  readonly suggestions: readonly ChartSuggestion[];
}

const chartIcons: Record<string, string> = {
  bar: '📊',
  line: '📈',
  pie: '🥧',
  scatter: '📍',
  histogram: '📉',
  heatmap: '🔥',
};

const priorityColors: Record<string, string> = {
  high: '#107c10',
  medium: '#0078d4',
  low: '#999',
};

export const ChartSuggestionCard: React.FC<ChartSuggestionCardProps> = ({ suggestions }) => {
  if (suggestions.length === 0) return null;

  return (
    <ResultCard
      title="Graphiques suggérés"
      variant="analysis"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {suggestions.map((suggestion) => (
          <div
            key={suggestion.id}
            style={{
              borderRadius: '4px',
              border: `1px solid ${priorityColors[suggestion.priority]}`,
              padding: '12px',
              backgroundColor: suggestion.priority === 'high' ? '#f0f8ff' : '#fafafa',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <span>{chartIcons[suggestion.type]}</span>
              <span style={{ fontWeight: 'bold', fontSize: '13px' }}>
                {CHART_TYPE_LABELS[suggestion.type]}
              </span>
              <span
                style={{
                  fontSize: '10px',
                  padding: '2px 6px',
                  borderRadius: '3px',
                  backgroundColor: priorityColors[suggestion.priority],
                  color: 'white',
                  marginLeft: 'auto',
                }}
              >
                {suggestion.priority === 'high' ? 'Priorité haute' : suggestion.priority === 'medium' ? 'Priorité moyenne' : 'Priorité basse'}
              </span>
            </div>
            <div style={{ fontSize: '13px', marginBottom: '4px' }}>{suggestion.title}</div>
            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
              {suggestion.reason}
            </div>
            <div style={{ fontSize: '11px', color: '#999' }}>
              Colonnes: {suggestion.columns.join(', ')}
            </div>
          </div>
        ))}
      </div>
    </ResultCard>
  );
};
